// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"704":"ab5f6354","787":"c7f9bfe4","948":"57fedbcf"}[chunkId] + ".chunk.js";
};